
import { Button } from "./ui/button";
import { motion } from "motion/react";
import logokalpa from '../assets/logokalpa.png';
import { useLanguage } from "../context/LanguageContext";
import { LanguageSwitcher } from "./LanguageSwitcher";

export function Navbar() {
  const { t } = useLanguage();

  return (
    <motion.nav 
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.6, 0.05, 0.01, 0.9] }}
        className="relative z-50 backdrop-blur-2xl bg-[#051F20]/30 border-b border-[#8EB69B]/10 shadow-2xl"
      >
        <div className="max-w-7xl mx-auto px-6 py-5 lg:px-20 flex items-center justify-between">
          {/* Logo */}
          <motion.div 
            className="flex items-center gap-4"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            <motion.div
              className="relative"
              whileHover={{ rotate: [0, -5, 5, 0] }}
              transition={{ duration: 0.5 }}
            >
              <motion.div
                className="absolute -inset-2 bg-gradient-to-r from-[#C9A961]/20 to-[#8EB69B]/20 rounded-2xl blur-xl"
                animate={{
                  scale: [1, 1.1, 1],
                  opacity: [0.3, 0.6, 0.3]
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity
                }}
              />
              <img
                src={logokalpa}
                alt="Kalpakrushi"
                className="h-16 w-16 relative z-10 drop-shadow-2xl rounded-full object-cover border-2 border-[#C9A961]/30"
                loading="lazy"
              />
            </motion.div>
            <div>
              <span className="text-white text-2xl tracking-tight block">Kalpakrushi</span>
              <span className="text-[#C9A961] text-xs uppercase tracking-[0.2em]">AgriTech Solutions</span>
            </div>
          </motion.div>
          
          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            {[
              { key: 'home', href: '#' },
              { key: 'services', href: '#services' },
              { key: 'about', href: '#about' },
              { key: 'projects', href: '#projects' },
              { key: 'contact', href: '#contact' }
            ].map((item, idx) => (
              <motion.a
                key={item.key}
                href={item.href}
                className="relative text-white/90 hover:text-[#C9A961] transition-all duration-300 tracking-wide group"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 + 0.3 }}
                whileHover={{ y: -2 }}
              >
                {t(`nav.${item.key}`)}
                <motion.span 
                  className="absolute -bottom-2 left-0 h-0.5 bg-gradient-to-r from-[#C9A961] to-[#8EB69B]"
                  initial={{ width: 0 }}
                  whileHover={{ width: '100%' }}
                  transition={{ duration: 0.3 }}
                />
              </motion.a>
            ))}
          </div>
          
          {/* Language Switcher & CTA */}
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Button className="bg-gradient-to-r from-[#235347] to-[#8EB69B] text-white hover:shadow-2xl hover:shadow-[#8EB69B]/50 transition-all duration-300 px-8 py-6 rounded-full border border-[#C9A961]/30 relative overflow-hidden group">
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-[#C9A961]/20 to-transparent"
                  initial={{ x: '-100%' }}
                  whileHover={{ x: '100%' }}
                  transition={{ duration: 0.6 }}
                />
                <span className="relative z-10">{t('hero.cta')}</span>
              </Button>
            </motion.div>
          </div>
        </div>
      </motion.nav>
  )
}
